module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "checkbox",
    class: _vm.data.class
  }, [_c('span', [_vm._v(_vm._s(_vm.data.props.defaultValue ? "✔️" : "⬜") + " " + _vm._s(_vm.data.label))]), _vm._v(" "), (_vm.data.props.footnotes) ? _c('footnotes', {
    attrs: {
      "all-footnotes": _vm.footnotes,
      "local-footnotes": _vm.data.props.footnotes
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.props.url) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.data.props.url) ? _c('a', {
    attrs: {
      "href": _vm.data.props.url
    }
  }, [_vm._v(_vm._s(_vm.data.props.urlLabel))]) : _vm._e(), _vm._v(" "), (_vm.data.props.caption) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.data.props.caption) ? _c('span', {
    staticClass: "caption",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.data.props.caption))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63aaa740"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/CHECKBOX.vue
// module id = 692
// module chunks = 0